<template>
  <div>
    <div class="form-group">
      <label for="email">{{ $t('emailPlaceholder') }}</label>
      <input
        type="email"
        :placeholder="$t('emailPlaceholder')"
        name="email"
        id="email"
        v-model.trim="email"
        v-validate="'required|email'"
        :class="{'input': true, 'danger-border': errors.has('email') || !!emailErrorMessage}"
        @change="validateEmail"
        @blur="validateEmail"
      />
      <p class="error-info">
        <span v-if="errors.has('email') && showError.email">{{ errors.first('email') }}</span>
        <span v-else>{{ emailErrorMessage }}</span>
      </p>
    </div>

    <div class="form-group">
      <label for="password">{{ $t('passwordPlaceholder') }}</label>
      <input
        type="password"
        name="password"
        id="password"
        v-if="!isShowPwd"
        :placeholder="$t('passwordPlaceholder')"
        v-model.trim="password"
        v-validate="'required|min:6|max:20'"
        @keyup.enter="doRegister"
        @blur="showError.password = true"
        autocomplete="new-password"
        :class="{'input pwd': true, 'danger-border': errors.has('password')}"
      />
      <input
        type="text"
        name="password"
        id="password"
        v-if="isShowPwd"
        :placeholder="$t('passwordPlaceholder')"
        v-model.trim="password"
        v-validate="'required|min:6|max:20'"
        @keyup.enter="doRegister"
        @blur="showError.password = true"
        autocomplete="new-password"
        :class="{'input pwd': true, 'danger-border': errors.has('password')}"
      />
      <span class="show-pwd" @click="showPwd">
        <img src="/static/img/dashboard/ic_eye.svg" v-show="isShowPwd" alt="" />
        <img src="/static/img/dashboard/ic_eye_off.svg" v-show="!isShowPwd" alt="" />
      </span>
      <p class="error-info">
        <span v-if="errors.has('password') && showError.password">{{ errors.first('password') }}</span>
      </p>
    </div>
    <invitation-code v-model.trim="invitationCode"></invitation-code>

    <button type="button" class="form-submit line-button" @click="doRegister" v-if="!isLoading">{{ $t('signUp') }}</button>
    <spinner class="spinner-component" :show="isLoading"></spinner>
    <router-link class="sign-in" to="/login">{{ $t('signIn') }}</router-link>
  </div>
</template>

<style rel="stylesheet/scss" lang="scss" scoped>
@import '../../assets/scss/formstyle';
div.form-group {
  input {
    margin-top: .08rem;
    height: .54rem;
    line-height: .54rem;
    border: 1px solid #E0D7E3;
    border-radius: 42px;
    padding: 0 24px;
    font-size: 16px;
    &::placeholder {
      color: #ccc;
    }
    &.pwd {
      padding-right: 50px;
    }
  }
  .show-pwd {
    right: 24px;
    bottom: 37px;
  }
}
.form-submit {
  margin: .16rem 0 0;
  height: 54px;
  line-height: 54px;
  font-size: 18px;
  font-weight: 600;
  background-image: linear-gradient(125deg, #416CF8 0%, #EC55FF 100%);
  border-radius: 42px;
  position: relative;
  &::before {
    content: "";
    position: absolute;
    top: 4px;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(125deg, #416cf8 0%, #ec55ff 100%);
    border-radius: 42px;
    filter: blur(4px);
    -webkit-filter: blur(4px);
    -moz-filter: blur(4px);
    -ms-filter: blur(4px);
    -o-filter: blur(4px);
    z-index: -1;
  }
}
.sign-in {
  margin-top: 24px;
  display: block;
  height: 54px;
  line-height: 54px;
  font-size: 18px;
  color: #999999;
  text-align: center;
  border: 1px solid #E0D7E3;
  border-radius: 42px;
  background: #FFF;
}

@media (max-width: 767px) {
  div.form-group {
    input {
      height: 0.49rem;
      line-height: .49rem;
      font-size: 14px;
      padding: 0 16px;
    }
    .show-pwd {
      right: 16px;
      bottom: 25px;
    }
  }
  .error-info {
    margin-top: 0.02rem;
  }
  .form-submit, .sign-in {
    margin-top: .24rem;
    height: 49px;
    line-height: 49px;
    font-size: 16px;
  }
}
</style>

<script>
import Spinner from '../../components/Spinner.vue';
import InvitationCode from './InvitationCode.vue';
import bus from '../../assets/js/Bus';
import locales from './lang.js';
import { SET_USER_INFO } from '../../store/mutation-types';

export default {
  name: 'email-register',
  components: {
    Spinner,
    InvitationCode
  },
  data: function () {
    return {
      email: '',
      password: '',
      emailErrorMessage: '',
      isLoading: false,
      invitationCode: '',
      isShowPwd: false,
      showError: {
        email: false,
        password: false
      }
    };
  },
  computed: {
    redirectUrl() {
      if (this.$store.state.redirectUrl === '/dashboard') {
        this.$store.commit('setShowVerifyForm', false)
        return '/verify-email';
      }
      return this.$store.state.redirectUrl;
    }
  },
  created() {
    bus.$on('errors-changed', errors => {
      this.errors.remove('invitationCode');
      errors.errors.forEach(e => {
        this.errors.add(e.field, e.msg, e.rule, e.scope);
      });
    });
  },
  locales,
  watch: {
    email() {
      this.showError.email = false;
      this.emailErrorMessage = '';
    },
    password() {
      this.showError.password = false;
    }
  },
  methods: {
    validateEmail() {
      if (this.errors.has('email')) {
        this.showError.email = true;
        return;
      }
      this.$http.get('api/email/validate?email=' + this.email).then(
        response => {
          if (response.data.code === 0) {
            this.emailErrorMessage = '';
          } else {
            this.emailErrorMessage = response.data.message;
          }
        },
        response => {
          this.emailErrorMessage = '网络错误，请稍后再试';
        }
      );
    },
    doRegister: function () {
      // Event snippet for signUpEmail page
      window.dataLayer && window.dataLayer.push({ event: 'sign_up_email' });
      this.$ga.event('Email Register', 'Click', this.$store.state.trackEventLabel);
      for (let i in this.showError) {
        this.showError[i] = true;
      }
      if (this.errors.errors.length > 0) {
        return;
      }
      this.$validator.validateAll().then(success => {
        if (!success) {
          return;
        }
        if (this.emailErrorMessage !== '') {
          return;
        }
        new Promise((resolve, reject) => {
          this.isLoading = true;
          this.$http
            .post('api/register', {
              email: this.email,
              password: this.password,
              invitation_code: this.invitationCode === '' ? null : this.invitationCode,
              qr_token: window.sessionStorage.getItem('qr_token') || ''
            })
            .then(
              response => {
                if (response.data.code === 0) {
                  resolve(response.data.code);
                } else if (response.data.code === 164) {
                  this.emailErrorMessage = response.data.message;
                  this.isLoading = false;
                } else {
                  this.isLoading = false;
                }
              },
              response => {
                this.emailErrorMessage = '网络错误，请稍后再试';
                this.isLoading = false;
              }
            );
        }).then(code => {
          if (code === 0) {
            this.$ga.event('Email Register', 'Registered', this.$store.state.trackEventLabel);
            this.$http
              .post('api/login', {
                email: this.email,
                password: this.password,
                qr_token: window.sessionStorage.getItem('qr_token') || ''
              })
              .then(response => {
                this.isLoading = false;
                if (response.data.code === 0) {
                  window.localStorage.setItem('token', response.data.data.access_token);
                  this.$store.commit(SET_USER_INFO, response.data.data);
                  this.$router.push(this.redirectUrl);
                }
              });
          }
        });
      });
    },
    showPwd: function () {
      this.isShowPwd = !this.isShowPwd;
    }
  }
};
</script>



// WEBPACK FOOTER //
// EmailRegister.vue?02e3b047